export default "__VITE_ASSET__BQGgAF1l__"